// this file is automatically generated by version_generate.ts script
      export const gitInfo = {
          version: 'v3.24.2',
      };